





import _ from 'lodash';
import Spinner from '@/components/ui/Spinner.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { Debounce } from '@/decorators';
import scanner from '@/scanner';
import scannerManual from '@/scannerManual';
import queueGuard from '@/queue';
import { ordersAutoUpdater } from '@/actionScheduler';

@Component({
  components: {
    Spinner
  }
})
export default class App extends Vue {
  appReady: boolean = false;
  @Getter('security/isLogged') isLogged: boolean;
  @Getter('isOnline') isOnline: boolean;
  @Action('setOnline') setOnline: (isOnline: boolean) => undefined;
  @Action('order/updateOrders') updateOrders(): Promise<any> { return new Promise((a,b)=>{a();}); }

  @Debounce(300) postInitializeAppHook() {
    
    // TODO: activate code below when offline mode detection will be possible
    if (this.isLogged && _.get(this.$router, 'currentRoute.name') !== 'dashboard-orders' && !this.isOnline) {
      this.$router.push({name: 'dashboard-orders'});
    }
  }

  attachGlobalListeners() {
    if (typeof window !== 'undefined') {
      this.setOnline(navigator.onLine);
      window.addEventListener('online',  this.onlineHandler);
      window.addEventListener('offline', this.offlineHandler);
    }
    scanner.start();
    scannerManual.start();
    ordersAutoUpdater.start();
  }
  
  detachGlobalListeners() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('online',  this.onlineHandler);
      window.removeEventListener('offline', this.offlineHandler);
    }
    scanner.stop();
    scannerManual.stop();
    ordersAutoUpdater.destroy();
  }

  onlineHandler() {
    this.setOnline(true);
  }

  offlineHandler() {
    this.setOnline(false);
  }

  async mounted() {
    this.attachGlobalListeners();
    this.postInitializeAppHook();
    try {
      await this.$store.restored;
      if (this.canFetch) {
        await this.updateOrders();
      }
    } catch(e) {
      // toast or something similar can be used
    } finally {
      this.appReady = true;
      queueGuard.start();
    }
  };

  beforeDestroy() {
    this.detachGlobalListeners();      
  };

  get canFetch() {
    return this.isOnline && this.isLogged;
  }

}
